// LiveFit+: boton "Agregar" de las sugerencias de envio gratis.
// Agrega el producto con la API del carrito y avisa al tema con el mismo evento que usa el
// formulario de producto, para que el carrito (lateral o pagina) se actualice sin recargar.
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__lfFreeShipping) {
  window.__lfFreeShipping = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement && event.target.matches('[data-lf-fs-add]') ? event.target : null;
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button');
    const id = Number(new FormData(form).get('id'));
    if (!id || button?.disabled) return;
    if (button) {
      button.disabled = true;
      button.dataset.label = button.textContent;
      button.textContent = 'Agregando…';
    }

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(id), quantity: 1 }],
        promise: deferred.promise,
      })
    );

    const restore = (text) => {
      if (!button) return;
      button.disabled = false;
      button.textContent = text || button.dataset.label || 'Agregar';
    };

    try {
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(',') }),
      });
      const data = await res.json();
      const cart = await (await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();
      const failed = Boolean(data.status);
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          itemCount: 1,
          source: 'lf-free-shipping',
          sections: failed ? undefined : data.sections,
          didError: failed,
        },
      });
      if (failed) restore('Sin existencias');
    } catch (error) {
      deferred.reject(error);
      restore('Intenta de nuevo');
    }
  });
}
